var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal-line-wrapper"},[_c('hr',{class:_vm.customClass,style:(_vm.customStyle),attrs:{"width":_vm.width}})])
}
var staticRenderFns = []

export { render, staticRenderFns }